export default __webpack_public_path__ + "static/media/mc-1-rMAX.d9fb698b.avif";